import request from '../libs/request';

const res = 'EntityView';

export default {
  save(data) {
    return request({
      url: `api/${res}/save`,
      method: 'post',
      data
    });
  }
};
